import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getDepartmentsAdmin, updateDepartment, deleteDepartment } from '../../../../api/department'
import { Button, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import ToggleOffIcon from '@material-ui/icons/ToggleOff'
import ToggleOnIcon from '@material-ui/icons/ToggleOn'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

const DAY_LABELS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']

function formatWorkDays(days) {
  if (!days || !days.length) return '—'
  return days
    .slice()
    .sort((a, b) => a - b)
    .map((d) => DAY_LABELS[d] || d)
    .join(', ')
}

function formatSites(sites) {
  if (!Array.isArray(sites) || !sites.length) return '—'
  return sites
    .map((raw) => {
      const name = typeof raw === 'string' ? raw : raw?.name
      if (!name) return null
      const own = typeof raw === 'object' && raw.useGenericSchedule === false
      return own ? `${name} (propio)` : name
    })
    .filter(Boolean)
    .join(', ') || '—'
}

function getData(departments) {
  return departments.map((d) => ({
    id: d._id,
    name: d.name,
    active: d.active !== false,
    schedule: `${d.workStart || '09:00'} – ${d.workEnd || '14:00'} · ${d.slotDurationMinutes || 30} min`,
    workDays: formatWorkDays(d.workDays),
    sites: formatSites(d.sites),
  }))
}

export default function DepartmentsPage() {
  const [raw, setRaw] = useState([])
  const [data, setData] = useState([])
  const [selected, setSelected] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    const elem = raw.find((item) => item._id === cell)
    return (
      <>
        <Tooltip title="Editar horario">
          <Button style={buttonsStyle} size="small" onClick={() => history.push('/edit-department/' + cell)}>
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title={elem?.active !== false ? 'Desactivar' : 'Activar'}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelected(elem)
              setOpenConfirmDialog(1)
            }}
          >
            {elem?.active !== false ? <ToggleOffIcon /> : <ToggleOnIcon style={{ color: 'red' }} />}
          </Button>
        </Tooltip>
        <Tooltip title="Eliminar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelected(elem)
              setOpenConfirmDialog(2)
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    )
  }

  const columns = [
    { dataField: 'name', text: 'Servicio', sort: true },
    { dataField: 'schedule', text: 'Horario genérico', sort: true },
    { dataField: 'workDays', text: 'Días laborables', sort: true },
    { dataField: 'sites', text: 'Centros', sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter },
  ]

  useEffect(() => {
    getDepartmentsAdmin()
      .then((res) => {
        if (res.status === 200) {
          setRaw(res.data)
          setData(getData(res.data))
          setRefresh(false)
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron cargar los servicios.' })
      })
  }, [refresh])

  return (
    <Card>
      <CardHeader title="Servicios y horarios de cita previa">
        <CardHeaderToolbar>
          <button type="button" className="btn btn-primary" onClick={() => history.push('/edit-department')}>
            Añadir servicio
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <p style={{ marginBottom: 16, color: '#666' }}>
          Configura el horario genérico de cada servicio y, si aplica, los centros donde se atiende. Cada centro puede usar el horario genérico o uno propio. Los ciudadanos solo podrán reservar huecos libres generados a partir de estos datos.
        </p>
        <Table data={data} columns={columns} />
        <ConfirmDialog
          title={`¿${selected?.active !== false ? 'Desactivar' : 'Activar'} este servicio?`}
          open={openConfirmDialog === 1}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            updateDepartment(selected._id, { active: selected?.active === false })
              .then((res) => {
                if (res.status === 200) {
                  alertSuccess({ title: 'OK', customMessage: 'Estado actualizado.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo cambiar el estado.' })
              })
          }}
        />
        <ConfirmDialog
          title="¿Eliminar este servicio?"
          open={openConfirmDialog === 2}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteDepartment(selected._id)
              .then((res) => {
                if (res.status === 200 || res.status === 204) {
                  alertSuccess({ title: 'Eliminado', customMessage: 'Servicio eliminado.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo eliminar.' })
              })
          }}
        />
      </CardBody>
    </Card>
  )
}
